import { useEffect, useState } from 'react';

export default function useIsLandscape() {
    const getIsLandscape = () => window.matchMedia('(max-width: 1024px) and (orientation: landscape)').matches;

    const [isLandscape, setIsLandscape] = useState(getIsLandscape);

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 1024px) and (orientation: landscape)');
        const handleChange = () => setIsLandscape(mq.matches);
        mq.addEventListener('change', handleChange);

        window.addEventListener('resize', handleChange);
        return () => {
            mq.removeEventListener('change', handleChange);
            window.removeEventListener('resize', handleChange);
        };
    }, []);

    return isLandscape;
}
